import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ========== SEO OPTIMIZATION ==========
// Set dynamic meta tags for better search engine visibility
(function setSEOMetaTags() {
  const profile = {
    name: "Harsha Naga Sai Peddoju",
    role: "Software Engineer & Full Stack Developer",
    description: "Portfolio of Harsha Naga Sai Peddoju – building scalable web applications, full‑stack solutions, and real‑world digital products. Explore projects, certifications, and experience.",
    keywords: "Harsha Naga Sai, Full Stack Developer, React, Node.js, Portfolio, Software Engineer, Web Developer, Chennai, PROCO, EdTech",
    author: "Harsha Naga Sai Peddoju",
    url: "https://harshapeddoju.in", // Replace with your actual domain
    image: "https://harshapeddoju.in/assets/profile.jpg" // Optional: social preview image
  };

  // Update or create meta tags
  const setMetaTag = (name, content, isProperty = false) => {
    let selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
    let meta = document.querySelector(selector);
    if (!meta) {
      meta = document.createElement('meta');
      if (isProperty) meta.setAttribute('property', name);
      else meta.setAttribute('name', name);
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', content);
  };

  // Title
  document.title = `${profile.name} | ${profile.role}`;

  // Basic meta tags
  setMetaTag('description', profile.description);
  setMetaTag('keywords', profile.keywords);
  setMetaTag('author', profile.author);
  setMetaTag('viewport', 'width=device-width, initial-scale=1.0');
  setMetaTag('robots', 'index, follow');

  // Open Graph (for social media)
  setMetaTag('og:title', `${profile.name} – ${profile.role}`, true);
  setMetaTag('og:description', profile.description, true);
  setMetaTag('og:type', 'website', true);
  setMetaTag('og:url', profile.url, true);
  setMetaTag('og:image', profile.image, true);
  setMetaTag('og:site_name', profile.name, true);

  // Twitter Card
  setMetaTag('twitter:card', 'summary_large_image');
  setMetaTag('twitter:title', `${profile.name} | ${profile.role}`);
  setMetaTag('twitter:description', profile.description);
  setMetaTag('twitter:image', profile.image);

  // Canonical URL (avoid duplicate content)
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', profile.url);
})();

// ========== RENDER REACT APP ==========
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();